/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  CreatePropertyPhotoRequest,
  GetAppPropertyApiPropertyphotoListpropertyphotosInvoke200,
  GetAppPropertyApiPropertyphotoListpropertyphotosInvokeParams,
  NotFoundErrorResponse,
  PropertyPhotoApiResource,
  UnauthorizedErrorResponse,
  UpdatePropertyPhotoRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type postApiPropertyPhotoCreateResponse201 = {
  data: PropertyPhotoApiResource
  status: 201
}

export type postApiPropertyPhotoCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiPropertyPhotoCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiPropertyPhotoCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiPropertyPhotoCreateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiPropertyPhotoCreateResponseSuccess = (postApiPropertyPhotoCreateResponse201) & {
  headers: Headers;
};
export type postApiPropertyPhotoCreateResponseError = (postApiPropertyPhotoCreateResponse400 | postApiPropertyPhotoCreateResponse401 | postApiPropertyPhotoCreateResponse403 | postApiPropertyPhotoCreateResponse404) & {
  headers: Headers;
};

export type postApiPropertyPhotoCreateResponse = (postApiPropertyPhotoCreateResponseSuccess | postApiPropertyPhotoCreateResponseError)

export const getPostApiPropertyPhotoCreateUrl = (id: number,) => {


  

  return `/api/properties/${id}/photos`
}

export const postApiPropertyPhotoCreate = async (id: number,
    createPropertyPhotoRequest: CreatePropertyPhotoRequest, options?: RequestInit): Promise<postApiPropertyPhotoCreateResponse> => {
  
  return customFetch<postApiPropertyPhotoCreateResponse>(getPostApiPropertyPhotoCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPropertyPhotoRequest,)
  }
);}


export type deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse204 = {
  data: void
  status: 204
}

export type deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponseSuccess = (deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse204) & {
  headers: Headers;
};
export type deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponseError = (deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse401 | deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse403 | deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse404) & {
  headers: Headers;
};

export type deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse = (deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponseSuccess | deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponseError)

export const getDeleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeUrl = (propertyId: number,
    photoId: number,) => {


  

  return `/api/properties/${propertyId}/photos/${photoId}`
}

export const deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvoke = async (propertyId: number,
    photoId: number, options?: RequestInit): Promise<deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse> => {
  
  return customFetch<deleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeResponse>(getDeleteAppPropertyApiPropertyphotoDeletepropertyphotoInvokeUrl(propertyId,photoId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse200 = {
  data: PropertyPhotoApiResource
  status: 200
}

export type patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponseSuccess = (patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse200) & {
  headers: Headers;
};
export type patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponseError = (patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse400 | patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse401 | patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse403 | patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse404) & {
  headers: Headers;
};

export type patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse = (patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponseSuccess | patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponseError)

export const getPatchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeUrl = (propertyId: number,
    photoId: number,) => {


  

  return `/api/properties/${propertyId}/photos/${photoId}`
}

export const patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvoke = async (propertyId: number,
    photoId: number,
    updatePropertyPhotoRequest: UpdatePropertyPhotoRequest, options?: RequestInit): Promise<patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse> => {
  
  return customFetch<patchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeResponse>(getPatchAppPropertyApiPropertyphotoUpdatepropertyphotoInvokeUrl(propertyId,photoId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePropertyPhotoRequest,)
  }
);}


export type getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse200 = {
  data: GetAppPropertyApiPropertyphotoListpropertyphotosInvoke200
  status: 200
}

export type getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponseSuccess = (getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse200) & {
  headers: Headers;
};
export type getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponseError = (getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse401 | getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse403 | getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse404) & {
  headers: Headers;
};

export type getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse = (getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponseSuccess | getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponseError)

export const getGetAppPropertyApiPropertyphotoListpropertyphotosInvokeUrl = (propertyId: number,
    params?: GetAppPropertyApiPropertyphotoListpropertyphotosInvokeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/photos?${stringifiedParams}` : `/api/properties/${propertyId}/photos`
}

export const getAppPropertyApiPropertyphotoListpropertyphotosInvoke = async (propertyId: number,
    params?: GetAppPropertyApiPropertyphotoListpropertyphotosInvokeParams, options?: RequestInit): Promise<getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse> => {
  
  return customFetch<getAppPropertyApiPropertyphotoListpropertyphotosInvokeResponse>(getGetAppPropertyApiPropertyphotoListpropertyphotosInvokeUrl(propertyId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


